export const getColor = (index: number) => {
  let color: string = "#595959";
  if (index <= 7) {
    color = "#FF0000";
  }
  if (index > 7 && index <= 11) {
    color = "#FF2F00";
  }
  if (index > 11 && index <= 14) {
    color = "#FF8C00";
  }
  if (index > 11 && index <= 18) {
    color = "#FF4E00";
  }
  if (index > 18 && index <= 21) {
    color = "#FF5B00";
  }
  if (index > 21 && index <= 25) {
    color = "#FF6D00";
  }
  if (index > 25 && index <= 29) {
    color = "#FF7F00";
  }
  if (index > 29 && index <= 33) {
    color = "#FF9000";
  }
  if (index > 33 && index <= 36) {
    color = "#FF9D00";
  }
  if (index > 36 && index <= 40) {
    color = "#FFAF00";
  }
  if (index > 40 && index <= 43) {
    color = "#FFBC00";
  }
  if (index > 43 && index <= 46) {
    color = "#FFCA00";
  }
  if (index > 46 && index <= 50) {
    color = "#FFDB00";
  }
  if (index > 50 && index <= 53) {
    color = "#FFE800";
  }
  if (index > 53 && index <= 56) {
    color = "#FFF600";
  }
  if (index > 56 && index <= 60) {
    color = "#F3FB03";
  }
  if (index > 60 && index <= 63) {
    color = "#E1F509";
  }
  if (index > 63 && index <= 66) {
    color = "#CFF00F";
  }
  if (index > 66 && index <= 70) {
    color = "#B6E816";
  }
  if (index > 70 && index <= 76) {
    color = "#92DD22";
  }
  if (index > 76 && index <= 83) {
    color = "#67D02F";
  }
  if (index > 83 && index <= 90) {
    color = "#3CC23C";
  }
  if (index > 90 && index <= 96) {
    color = "#18B748";
  }
  if (index > 96 && index <= 100) {
    color = "#00B050";
  }
  return color + 90;
};
